import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchExperienceTripsDtl } from "../services/ExperienceTripsDtl";
import { API_BASE } from "../api/apiConfig";

const Experiencebooknow = () => {
  const { id } = useParams();
  const [ExperienceTripsDtldata, setExperienceTripsDtldata] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchExperienceTripsDtl(decodeURIComponent(id));

      if (res?.data) {
         setExperienceTripsDtldata(res.data[0]);
      }
      setLoading(false);
    };

    loadBanner();
  }, [id]);


  // Modal
  const [open, setOpen] = useState(false);

  
const [openDay, setOpenDay] = useState(1);


  if (loading) return <p className="text-center py-10">Loading...</p>;
  if (!ExperienceTripsDtldata) return <p className="text-center py-10">No Data found</p>;

  return (
      <>

    {ExperienceTripsDtldata.local_experts_details && ExperienceTripsDtldata.local_experts_details.length > 0 && (
      <div className="bg-white rounded-2xl overflow-hidden border border-slate-200 shadow-sm cursor-pointer group hover:shadow-md transition-all duration-300">
        <div className="relative h-48 w-full overflow-hidden">
          <img
            alt={ExperienceTripsDtldata.local_experts_details[0].name}
            loading="lazy"
            decoding="async"
            data-nimg="fill"
            className="object-cover transition-transform duration-500 group-hover:scale-105"
            style={{
              position: "absolute",
              height: "100%",
              width: "100%",
              objectPosition: "center",
              inset: 0
            }}
            src={`${API_BASE}/${ExperienceTripsDtldata.local_experts_details[0].profile_image}`}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <p className="text-[11px] text-white/70 mb-0.5">
              Your Travel Expert
            </p>
            <h3 className="font-bold text-white text-lg">
              {ExperienceTripsDtldata.local_experts_details[0].name}
            </h3>
          </div>
        </div>
        <div className="px-4 py-2.5 flex items-center justify-between bg-slate-50" onClick={() => setOpen(true)}>
          <span className="text-sm text-slate-600">View profile</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-right h-4 w-4 text-slate-400 group-hover:text-primary transition-colors"
          >
            <path d="m9 18 6-6-6-6" />
          </svg>
        </div>
      </div>
    )}
    
       <div className="bg-white border border-slate-200 rounded-2xl p-5 shadow-sm">
          <div className="flex items-baseline gap-2 mb-3">
            <span className="text-slate-400 line-through text-sm">
              ₹{ExperienceTripsDtldata.difficulties}
            </span>
            <span className="text-2xl font-bold text-slate-900">
              ₹{ExperienceTripsDtldata.charges}
            </span>
            <span className="text-slate-500 text-sm">/ person</span>
          </div>
          <div className="space-y-2 mb-4 text-sm">
            <div className="flex items-center justify-between">
              <span className="text-slate-500">Dates</span>
              <span className="font-medium text-slate-900">
                {new Date(
                ExperienceTripsDtldata?.expdate && ExperienceTripsDtldata?.expdate !== "null"
                  ? ExperienceTripsDtldata.expdate
                  : new Date()
              ).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-slate-500">Duration</span>
              <span className="font-medium text-slate-900">
                {ExperienceTripsDtldata?.no_of_days} Days / {ExperienceTripsDtldata?.duration}
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-slate-500">Spots Left</span>
              <span className="font-medium text-primary">{ExperienceTripsDtldata.spots}</span>
            </div>
          </div>
          <a target="_blank" href="https://wa.me/918920866123" className="inline-flex items-center justify-center whitespace-nowrap rounded-md ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 px-4 py-2 w-full bg-primary text-white hover:bg-primary/90 h-11 text-sm font-semibold">
            Book This Trip
          </a>
          <p className="text-center text-[11px] text-slate-500 mt-2">
            Reserve your spot with ₹{ExperienceTripsDtldata.charges} deposit
          </p>
        </div>


        {/* Modal Popup */}
{open &&
  ExperienceTripsDtldata?.local_experts_details?.length > 0 && (


        <div className="fixed inset-0 z-[100] flex items-end md:items-center justify-center">
  <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
  <div className="relative bg-white rounded-t-3xl md:rounded-3xl max-w-4xl w-full max-h-[90vh] md:max-h-[90vh] overflow-hidden shadow-2xl flex flex-col md:flex-row md:m-4">
    <button onClick={() => setOpen(false)}  className="absolute top-3 right-3 md:top-4 md:right-4 w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/90 flex items-center justify-center hover:bg-white transition-colors z-10 shadow-md">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-x h-4 w-4 md:h-5 md:w-5 text-slate-600"
      >
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
      </svg>
    </button>
    <div className="relative w-full md:w-2/5 flex-shrink-0">
      <div className="md:hidden flex justify-center items-start pt-4 pb-2 px-4 bg-slate-50">
        <div className="relative w-32 h-40 rounded-2xl overflow-hidden shadow-lg">
          <img
            alt={ExperienceTripsDtldata.local_experts_details[0].name}
            className="absolute inset-0 w-full h-full object-cover"
            src={`${API_BASE}/${ExperienceTripsDtldata.local_experts_details[0].profile_image}`}
          />
        </div>
      </div>
      <div className="md:hidden text-center pb-3 bg-slate-50">
        <h2 className="text-lg font-bold text-slate-900 mb-0.5">
          {ExperienceTripsDtldata.local_experts_details[0].name}
        </h2>
        {/*<p className="text-primary text-xs font-medium">
          High Altitude &amp; Adventure Expert
        </p>*/}
      </div>
      <div className="hidden md:block relative h-full min-h-[600px]">
        <img
          alt={ExperienceTripsDtldata.local_experts_details[0].name}
          className="absolute inset-0 w-full h-full object-cover"
          src={`${API_BASE}/${ExperienceTripsDtldata.local_experts_details[0].profile_image}`}
        />
      </div>
    </div>
    <div className="flex-1 p-4 md:p-8 overflow-y-auto max-h-[60vh] md:max-h-[90vh]">
      <div className="hidden md:block mb-6">
        <h2 className="text-3xl font-bold text-slate-900 mb-2">
          {ExperienceTripsDtldata.local_experts_details[0].name}
        </h2>
        {/*<p className="text-primary font-medium text-lg mb-2">
          High Altitude &amp; Adventure Expert
        </p>*/}
        <div className="flex items-center gap-2 text-slate-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-map-pin h-4 w-4"
          >
            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
            <circle cx={12} cy={10} r={3} />
          </svg>
          <span>{ExperienceTripsDtldata.local_experts_details[0].city}, {ExperienceTripsDtldata.local_experts_details[0].state_name}</span>
        </div>
      </div>
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <a
          href={ExperienceTripsDtldata.local_experts_details[0].instagram}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white px-3 md:px-4 py-2 rounded-full text-xs md:text-sm font-medium hover:opacity-90 transition-opacity"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-instagram h-4 w-4"
          >
            <rect width={20} height={20} x={2} y={2} rx={5} ry={5} />
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
            <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
          </svg>
          Instagram
        </a>
        <a
          href={ExperienceTripsDtldata.local_experts_details[0].facebook}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 bg-[#1877F2] text-white px-3 md:px-4 py-2 rounded-full text-xs md:text-sm font-medium hover:opacity-90 transition-opacity"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-facebook h-4 w-4"
          >
            <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
          </svg>
          Facebook
        </a>
      </div>
      <div className="mb-4 md:mb-6">
        <h3 className="font-semibold text-slate-900 mb-2 md:mb-3 text-sm md:text-base">
          About
        </h3>
        <p className="text-slate-600 leading-relaxed text-xs md:text-base"
                dangerouslySetInnerHTML={{
                  __html: ExperienceTripsDtldata.local_experts_details[0].about
                }}>
        </p>
      </div>
      {/*<div className="mb-4 md:mb-6">
        <h3 className="font-semibold text-slate-900 mb-2 md:mb-3 text-sm md:text-base flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-globe h-4 w-4 text-primary"
          >
            <circle cx={12} cy={12} r={10} />
            <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
            <path d="M2 12h20" />
          </svg>
          Places Explored
        </h3>
        <div className="flex flex-wrap gap-1.5 md:gap-2">
          <span className="bg-emerald-50 text-emerald-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-emerald-200">
            Ladakh
          </span>
          <span className="bg-emerald-50 text-emerald-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-emerald-200">
            Spiti Valley
          </span>
          <span className="bg-emerald-50 text-emerald-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-emerald-200">
            Zanskar
          </span>
          <span className="bg-emerald-50 text-emerald-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-emerald-200">
            Nepal
          </span>
          <span className="bg-emerald-50 text-emerald-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-emerald-200">
            Bhutan
          </span>
          <span className="bg-emerald-50 text-emerald-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-emerald-200">
            Tibet
          </span>
        </div>
      </div>*/}
      <div className="mb-4 md:mb-6">
        <h3 className="font-semibold text-slate-900 mb-2 md:mb-3 text-sm md:text-base flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-languages h-4 w-4 text-primary"
          >
            <path d="m5 8 6 6" />
            <path d="m4 14 6-6 2-3" />
            <path d="M2 5h12" />
            <path d="M7 2h1" />
            <path d="m22 22-5-10-5 10" />
            <path d="M14 18h6" />
          </svg>
          Speaks
        </h3>
        <div className="flex flex-wrap gap-1.5 md:gap-2">
        {(ExperienceTripsDtldata?.local_experts_details?.[0]?.language || "")
        .split(",")
        .filter(Boolean)
        .map((lang, index) => (
          <span key={index} className="bg-blue-50 text-blue-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-blue-200">
            {lang}
          </span>
        ))}
        </div>
      </div>
      {/*<div className="mb-4 md:mb-6">
        <h3 className="font-semibold text-slate-900 mb-2 md:mb-3 text-sm md:text-base flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-gallery-horizontal h-4 w-4 text-primary"
          >
            <path d="M2 3v18" />
            <rect width={12} height={18} x={6} y={3} rx={2} />
            <path d="M22 3v18" />
          </svg>
          Gallery
        </h3>
        <div className="grid grid-cols-4 gap-2">
          <button className="relative aspect-square rounded-lg overflow-hidden cursor-pointer group">
            <img
              alt="Gallery 1"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              src="/assets/images/ladakh-hero-banner.jpg"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
          </button>
          <button className="relative aspect-square rounded-lg overflow-hidden cursor-pointer group">
            <img
              alt="Gallery 2"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              src="/assets/images/pangong-lake-camping.jpg"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
          </button>
          <button className="relative aspect-square rounded-lg overflow-hidden cursor-pointer group">
            <img
              alt="Gallery 3"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              src="/assets/images/nubra-valley-dunes.jpg"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
          </button>
          <button className="relative aspect-square rounded-lg overflow-hidden cursor-pointer group">
            <img
              alt="Gallery 4"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              src="/assets/images/ladakh-monastery.jpg"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
          </button>
        </div>
      </div>
      <div className="mb-4 md:mb-6">
        <h3 className="font-semibold text-slate-900 mb-2 md:mb-3 text-sm md:text-base">
          Expertise
        </h3>
        <div className="flex flex-wrap gap-1.5 md:gap-2">
          <span className="bg-primary/10 text-primary text-xs md:text-sm px-2.5 md:px-4 py-1 md:py-1.5 rounded-full font-medium">
            High Altitude
          </span>
          <span className="bg-primary/10 text-primary text-xs md:text-sm px-2.5 md:px-4 py-1 md:py-1.5 rounded-full font-medium">
            Adventure Expert
          </span>
          <span className="bg-slate-100 text-slate-600 text-xs md:text-sm px-2.5 md:px-4 py-1 md:py-1.5 rounded-full">
            Local Expert
          </span>
          <span className="bg-slate-100 text-slate-600 text-xs md:text-sm px-2.5 md:px-4 py-1 md:py-1.5 rounded-full">
            Verified Host
          </span>
        </div>
      </div>*/}
      <a href="https://wa.me/918920866123" className="inline-flex items-center justify-center whitespace-nowrap rounded-md ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 px-4 py-2 w-full bg-primary text-white hover:bg-primary/90 h-10 md:h-12 text-sm md:text-base font-medium">
        Book Trip with Tenzing
      </a>
    </div>
  </div>
</div>

)}

    </>
  );
};

export default Experiencebooknow;
